import { useQuery } from "@tanstack/react-query";
import { useCurrentInstanceId } from "./useInstanceId";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";

export function useCurrentInstanceMetadata() {
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();
  return useQuery({
    queryKey: instances.current(instanceId).scenario,
    queryFn: () => knopClient.getScenario(instanceId),
  });
}
